// extracted by mini-css-extract-plugin
export default {"tooltipColor":"rgb(var(--color-hare))","row-wrap":"Query_row-wrap__XdiMz","textbox":"Query_textbox__W9Nd6","toggle":"Query_toggle__WCju9"};